import axios from "axios";

/**
 * The back office's 402 when an action costs more QCredits than the company
 * has: following a shipment, or a paid tool call through `/api/tools`.
 */
export type InsufficientCredits = {
  code: "insufficient_credits";
  message: string;
  needed: number;
  balance: number;
  buy_url?: string;
};

/**
 * Recognised by `code`, never by status: the `/api/tools/*` proxy also passes
 * on the gateway's own errors, which carry no code and mean an API limit,
 * a different product.
 */
export const getCreditDenial = (error: unknown): InsufficientCredits | null => {
  if (!axios.isAxiosError(error)) {
    return null;
  }

  const data: unknown = error.response?.data;
  if (typeof data !== "object" || data === null || !("code" in data)) {
    return null;
  }

  return data.code === "insufficient_credits" ? (data as InsufficientCredits) : null;
};

type Listener = (denial: InsufficientCredits) => void;

const listeners = new Set<Listener>();

/**
 * A request anywhere in the widget can run out of QCredits, but only the app
 * root can show a modal. Requests announce it here; the root listens.
 */
export const creditDenialEvents = {
  emit(denial: InsufficientCredits): void {
    listeners.forEach((listener) => listener(denial));
  },

  /** Returns the unsubscribe function, so it drops straight into an effect. */
  subscribe(listener: Listener): () => void {
    listeners.add(listener);

    return () => {
      listeners.delete(listener);
    };
  },
};
